import { useCallback, useEffect, useRef, useState } from 'react';
import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchServiceTypes = () => {
  const [loading, setLoading] = useState();
  const [serviceTypes, setServiceTypes] = useState([]);
  const isMounted = useRef(true);

  const fetchAllServiceTypes = useCallback(async () => {
    setLoading(true);
    if (serviceTypes.length === 0) {
      try {
        const response = await lineEndpoint.getServiceType();
        if (response.status === 200) {
          if (isMounted.current) setServiceTypes(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllServiceTypes().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllServiceTypes]);

  return {
    loading,
    serviceTypes,
  };
};